import { badgeCount, useStore } from '../store';

/**
 * Keeps the installed app's icon badge (Badging API) in step with unread mentions and DMs
 * while the app is open. Pushes set it from the service worker while it's closed.
 */
type BadgeNavigator = Navigator & {
  setAppBadge?: (n?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

export function setBadge(n: number) {
  const nav = navigator as BadgeNavigator;
  if (!nav.setAppBadge || !nav.clearAppBadge) return;
  (n > 0 ? nav.setAppBadge(n) : nav.clearAppBadge()).catch(() => {});
}

let stop: (() => void) | null = null;

export function startBadge() {
  stop?.();
  let last = -1;
  const apply = () => {
    const n = badgeCount(useStore.getState());
    if (n === last) return;
    last = n;
    setBadge(n);
  };
  apply();
  stop = useStore.subscribe(apply);
}

export function stopBadge() {
  stop?.();
  stop = null;
  setBadge(0);
}
